<mat-card id="component-container" style="padding-bottom: 1px; margin-top: 5%; margin-bottom: 3%;">
  <mat-card>
    <h2 id="title">PTM Prediction</h2>
  </mat-card>

  <app-musitedeep-prediction></app-musitedeep-prediction>
</mat-card>
